module.exports = __webpack_public_path__ + "img/characters.94ea65c8.png";